import { createApp } from 'vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'
import stores from './stores'
import router, { initRouterGuards } from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import App from './App.vue'

import { initFirebase, useFirebase } from './services/firebase'
import { onAuthStateChanged } from 'firebase/auth'
import { useUserStore } from './stores/user'
import { gtmEnabled, gtmKey } from './runtime-config'

async function bootstrap() {
  //Inicializa Firebase primero
  await initFirebase()
  const { auth } = useFirebase()
  initRouterGuards(auth)
  //Crea la app UNA sola vez
  const app = createApp(App)
  app.use(stores)

  app.use(i18n)
  app.use(createVuestic({ config: vuesticGlobalConfig }))

  if (gtmEnabled()) {
    app.use(
      createGtm({
        id: gtmKey(),
        debug: false,
        vueRouter: router,
      }),
    )
  }

  //Espera al estado de auth SOLO para decisiones de navegación
  onAuthStateChanged(auth, () => {
    app.use(router)
    //cargar información de usuario antes de renderizar la app
    const { me } = useUserStore()
    me().then(() => {
      //load application
      app.mount('#app')
    })
  })
}

bootstrap()
